import React from 'react';

import IndicatorsModule from 'indicators';

const Indicators = () => (
  <IndicatorsModule />
);

export default Indicators;
